import { useContext } from 'react';
import {
  ViewRFIMachineContext,
  ViewRFIMachineContextValue,
} from './ViewRFIMachineContext';

const useViewRfiMachine = (): ViewRFIMachineContextValue =>
  useContext(ViewRFIMachineContext) as ViewRFIMachineContextValue;

export { useViewRfiMachine };
